export const normalizeAuthPayload = (payload) => {
  const resolvedPayload =
    payload?.data && (payload.data.token || payload.data.lawyer)
      ? payload.data
      : payload || null;

  const tokenValue = resolvedPayload?.token || null;
  const teamData = Array.isArray(resolvedPayload?.team_data)
    ? resolvedPayload.team_data
    : [];
  const lawyer = resolvedPayload?.lawyer || null;
  const userRecord =
    resolvedPayload?.user ||
    resolvedPayload?.user_data ||
    resolvedPayload?.profile ||
    lawyer ||
    resolvedPayload ||
    null;
  const lawyerId =
    lawyer?.id ||
    lawyer?.lawyer_id ||
    resolvedPayload?.lawyer_id ||
    userRecord?.lawyer_id ||
    null;
  const userId =
    resolvedPayload?.user?.id ||
    resolvedPayload?.id ||
    userRecord?.id ||
    lawyerId ||
    null;

  return {
    raw: resolvedPayload,
    tokenValue,
    teamData,
    lawyer,
    userRecord,
    lawyerId,
    userId,
  };
};

export const resolveAccessState = (teamData, fallbackAccess) => {
  let finalAccess = fallbackAccess;
  let memberId = null;

  if (Array.isArray(teamData) && teamData.length > 0) {
    const mergedRoles = [];
    const roleIds = new Set();
    teamData.forEach((team) => {
      (team?.access || []).forEach((role) => {
        if (role && !roleIds.has(role.id)) {
          roleIds.add(role.id);
          mergedRoles.push(role);
        }
      });
      if (!memberId) {
        memberId = team?.team_member_lawyer_id || team?.lawyer?.id || null;
      }
    });
    finalAccess = mergedRoles.length > 0 ? mergedRoles : fallbackAccess;
  } else if (Array.isArray(teamData) && teamData.length === 0) {
    finalAccess = [{ direct_login: true }];
  }

  return { finalAccess, memberId };
};
